export function useTextTransform(): {
  offsetOptionText: (event: Event, reset: boolean) => void
  typeWriter: (
    text: string,
    speed?: number,
    onUpdate?: (text: string) => void,
  ) => {
    start: () => Promise<void>
    stop: () => void
  }
} {
  const offsetOptionText = (event: Event, reset = false): void => {
    const optionTextEl = event.currentTarget as HTMLElement
    const innerTextEl = optionTextEl.firstChild as HTMLElement
    let transform: string, transitionDuration: string
    if (!reset) {
      const offset = Math.min(optionTextEl.clientWidth - innerTextEl.clientWidth, 0)
      const transitionDurationPerPixelInMillis = 10
      const transitionDurationInMillis = -offset * transitionDurationPerPixelInMillis
      transform = `translate3d(${offset}px,0,0)`
      transitionDuration = `${transitionDurationInMillis}ms`
    } else {
      transform = 'translate3d(0,0,0)'
      transitionDuration = ''
    }
    innerTextEl.style.transform = transform
    innerTextEl.style.transitionDuration = transitionDuration
  }

  const typeWriter = (text: string, speed = 20, onUpdate?: (text: string) => void) => {
    let timeoutId: number | null = null
    let currentIndex = 0

    const start = (): Promise<void> => {
      stop()
      currentIndex = 0

      return new Promise(resolve => {
        const animate = (): void => {
          if (currentIndex >= text.length) {
            resolve()
            return
          }

          if (text[currentIndex] === '<') {
            const htmlMatch = text.slice(currentIndex).match(/^<\/?[a-z][^>]*>/i)
            if (htmlMatch) {
              currentIndex += htmlMatch[0].length
            } else {
              currentIndex++
            }
          } else {
            currentIndex++
          }

          onUpdate?.(text.slice(0, currentIndex))
          timeoutId = setTimeout(animate, speed) as unknown as number
        }

        animate()
      })
    }

    const stop = (): void => {
      if (timeoutId) {
        clearTimeout(timeoutId)
        timeoutId = null
      }
    }

    return { start, stop }
  }

  return {
    offsetOptionText,
    typeWriter,
  }
}
